<template>
    <div class="tariffication_packet_items">

      <div class="response_table">
        <table>
          <thead style="">
            <tr>
              <th scope="col" class="w40"> ID </th>
              <th scope="col" class="w70"> ID(MNO) </th>
              <th scope="col"> traffic_type </th>
              <th scope="col"> create </th>
              <th scope="col"> imsi </th>
              <th scope="col"> iccid </th>
              <th scope="col"> limit / available / used </th>
              <th scope="col"> update </th>
            </tr>
          </thead>
          <tbody>
            <tr
                v-for="(item, key) in items"
                :key="key"
                :class="{ active_item: item.status > 0 }"
            >
              <td data-label="ID" class="w40">
                <span>{{ item.id }}</span>
              </td>
              <td data-label="mno_packet_item_id" class="w70">
                <span>{{ item.mno_packet_item_id }}</span>
              </td>
              <td data-label="traffic_type">
                <span> {{ traffic_type(item.traffic_type) }} </span>
              </td>
              <td data-label="create">
                <span> {{ get_date(item.ts_create) }} </span>
              </td>
              <td data-label="imsi">
                <span> {{ item.imsi }} </span>
              </td>
              <td data-label="iccid">
                <span> {{ item.iccid }} </span>
              </td>
              <td data-label="traffic_used">
                <span> {{ item.traffic_used }} / {{ item.mno_traffic_available }} / {{ item.traffic_used }} </span>
              </td>
              <td data-label="update">
                <span> {{ get_date(item.ts_update) }} </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>
<script>

export default {
  name: 'TariffPacketItemTarifficationPackets',
  components: {
  },
  props: {
    items: {}
  },
  computed: {
  },
  methods:{
    traffic_type(type) {
      if (type === 2) {
        return "Служебный";
      } else if (type === 1) {
        return "Пользовательский";
      }
      return "";
    }
  }
}
</script>
<style lang='scss' scoped>
.tariffication_packet_items {
  .response_table{
    padding: 0;
    .w40{
      width: 40px;
    }
    .w70{
      width: 70px;
    }
    .active_item {
      background-color: #41b88330;
    }
  }
}
</style>
